import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseInjuriesModel from "../../models/case-injuries";

export default class CaseInjuriesRepository extends BaseRepository {
  static modelClass = CaseInjuriesModel;
  modelName = "case-injuries";
}
